import * as React from 'react'
// libs
import styled from 'styled-components'
import { WrappedFieldArrayProps } from 'redux-form'
// types
import { IOption } from 'components/FormElements/Select'
// components
import ReduxEntitySelect from 'components/FormElements/ReduxForm/ReduxEntitySelect'
// graphql
import { OWNED_BY_SELECT_QUERY } from 'graphql/plan/queries'
// views
import { AddButton, Chip, ReviewerContainer } from 'components/Modals/CreateScheduledReviewModal/views'
// icons
import CloseIconOrigin from '@mui/icons-material/CloseRounded'
// utils
import { size } from 'polished'
import { userAndPositionProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

const CloseIcon = styled((props) => <CloseIconOrigin {...props} />)`
  && {
    cursor: pointer;
    margin-left: auto;
    ${size('20px')};
  }
`

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  > div {
    flex: 1;
  }
`

const Wrapper = styled.div``

const ReviewersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 16px;
`

interface IIncomingProps {
  chosenReviewersIds: string[]
  isRepeatingReview?: boolean
}

const renderReviewers: React.FunctionComponent<WrappedFieldArrayProps<any> & IIncomingProps> = ({
  chosenReviewersIds,
  fields,
  isRepeatingReview
}) => {
  const prepareOptions = (options: IOption[]) =>
    options.filter((option) => !chosenReviewersIds.some((reviewerId) => reviewerId === option.value))

  const removeField = (idx: number) => () => fields.remove(idx)

  const onAddClick = () => fields.push({})

  return (
    <Wrapper>
      <ReviewersContainer>
        {fields.map((field, idx) => {
          const { reviewer } = fields.get(idx)

          return (
            <ReviewerContainer key={idx} $hasReviewer={!!reviewer}>
              {!reviewer ? (
                <Container>
                  <ReduxEntitySelect
                    name={`${field}.reviewer`}
                    prepareOptions={prepareOptions}
                    query={OWNED_BY_SELECT_QUERY}
                    {...userAndPositionProps}
                  />
                  <CloseIcon onClick={removeField(idx)} />
                </Container>
              ) : (
                <Chip label={reviewer.label} onDelete={removeField(idx)} isRepeatingReview={isRepeatingReview} />
              )}
            </ReviewerContainer>
          )
        })}
      </ReviewersContainer>
      <AddButton onClick={onAddClick}>+ add a reviewer</AddButton>
    </Wrapper>
  )
}

export default renderReviewers
